/* Workflows Client barrel export */

import { WorkflowsClientMocked } from './workflowsClientMocked';

// Re-export types
export * from './workflowsTypes';

/* ---- Singleton Instance ---- */
// Workflows has no real backend yet — always use the in-code mocked client.

const workflowsClient = new WorkflowsClientMocked();

/** @deprecated Use workflowsClient directly */
export function getWorkflowsClient() { return workflowsClient; }

export { workflowsClient, WorkflowsClientMocked };
// Some pages instantiate their own client instance directly (`new WorkflowsClient()`);
// keep this name pointing at the mocked implementation since there's no real backend.
export { WorkflowsClientMocked as WorkflowsClient };
